import { observable, action } from 'mobx';
import {PModel} from "../models/PModel";
import {IPuzzleRecord} from "platform_common/types/data/PuzzleRecord";

/**
 * Store for Puzzle related state.
 */
export class PStore {

    @observable
    public p: PModel;

    /**
     * P store is an instance of the P model.
     *
     * @param {PModel} p
     */
    constructor(p: PModel) {
        this.p = p;
    }

    /**
     * Set puzzle being worked on.
     *
     * @param puzzleRecords
     */
    @action
    public setPuzzleRecord(puzzleRecord:IPuzzleRecord):void
    {
        this.p.puzzleRecord = puzzleRecord;
    }
}

export default PStore;